module.exports = __webpack_public_path__ + "img/blue-1.68906330.jpg";